import axios from "axios";

import config from "./config";

export default class DocumentosService {
  static async sendSolicitacao(nome,telefone, email,documento, mensagem ) {

    const bodyFormData = new FormData();
    bodyFormData.append("enviarDoc", "enviarDoc")
    bodyFormData.append("nome", nome);
    bodyFormData.append("telefone", telefone);
    bodyFormData.append("email", email);
    bodyFormData.append("documento", documento);
    bodyFormData.append("mensagem", mensagem);
    let response = "";
    try {
      response = await axios.post(config.URL_EMAIL_BASE, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    } catch (err) {
      return {status: false, error:err};
    }

    return response.data
  }
}
